module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-calendar-body"
  }, [_c('div', {
    staticClass: "weeks"
  }, _vm._l((_vm.weekNames), function(week, index) {
    return _c('strong', {
      key: index,
      staticClass: "week"
    }, [_vm._v(_vm._s(week))])
  }), 0), _vm._v(" "), _c('div', {
    ref: "dates",
    staticClass: "dates"
  }, [_c('div', {
    staticClass: "dates-bg"
  }, _vm._l((_vm.currentDates), function(week, index) {
    return _c('div', {
      key: index,
      staticClass: "week-row"
    }, _vm._l((week), function(day, index) {
      return _c('div', {
        key: index,
        staticClass: "day-cell",
        class: {
          'today': day.isToday, 'not-cur-month': !day.isCurMonth
        }
      }, [_c('p', {
        staticClass: "day-number"
      }, [_vm._v(_vm._s(day.monthDay))])])
    }), 0)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "dates-events"
  }, _vm._l((_vm.currentDates), function(week, index) {
    return _c('div', {
      key: index,
      staticClass: "events-week"
    }, _vm._l((week), function(day, index) {
      return _c('div', {
        key: index,
        staticClass: "events-day",
        class: {
          'today': day.isToday, 'not-cur-month': !day.isCurMonth
        },
        attrs: {
          "track-by": "$index"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.$_onDayClick(day.date, $event)
          }
        }
      }, [_c('p', {
        staticClass: "day-number"
      }, [_vm._v(_vm._s(day.monthDay))]), _vm._v(" "), _c('div', {
        staticClass: "event-box"
      }, [_vm._l((day.events), function(event, index) {
        return _c('p', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (event.cellIndex <= _vm.eventLimit),
            expression: "event.cellIndex <= eventLimit"
          }],
          key: index,
          staticClass: "event-item",
          class: [_vm.$_classNames(event.cssClass), {
            'is-start': _vm.$_isStart(event.start, day.date),
            'is-end': _vm.$_isEnd(event.end, day.date),
            'is-opacity': !event.isShow
          }],
          on: {
            "click": function($event) {
              return _vm.$$_onEventClick(event, $event)
            }
          }
        }, [_vm._v("\n              " + _vm._s(_vm.$_isBegin(event, day.date, day.weekDay)) + "\n            ")])
      }), _vm._v(" "), (day.events.length > _vm.eventLimit) ? _c('p', {
        staticClass: "more-link",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.$_selectThisDay(day, $event)
          }
        }
      }, [_vm._v("\n              + " + _vm._s(day.events[day.events.length - 1].cellIndex - _vm.eventLimit) + " more\n            ")]) : _vm._e()], 2)])
    }), 0)
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMore),
      expression: "showMore"
    }],
    staticClass: "more-events",
    style: ({
      left: _vm.morePos.left + 'px',
      top: _vm.morePos.top + 'px'
    })
  }, [_c('div', {
    staticClass: "more-header"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$_moreTitle(_vm.selectDay.date)))]), _vm._v(" "), _c('span', {
    staticClass: "close",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showMore = false
      }
    }
  }, [_vm._v("x")])]), _vm._v(" "), _c('div', {
    staticClass: "more-body"
  }, [_c('ul', {
    staticClass: "body-list"
  }, _vm._l((_vm.selectDay.events), function(event, index) {
    return _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (event.isShow),
        expression: "event.isShow"
      }],
      key: index,
      staticClass: "body-item",
      on: {
        "click": function($event) {
          return _vm.$$_onEventClick(event, $event)
        }
      }
    }, [_vm._v("\n            " + _vm._s(event.title) + "\n          ")])
  }), 0)])]), _vm._v(" "), _vm._t("body-card")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-063b880e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/body.vue
// module id = 339
// module chunks = 0